import React from "react";
import FooterComponent from "./../../Generic/Footer/FooterComponent";
import HeaderComponent from "./../../Generic/Header/HeaderComponent";
import SeoMeta from "./../../Generic/SEO/SeoMeta";
import ProductListing from "../Catalog/ProductListing";
import { getCategoryMeta } from "../Catalog/categoryMeta";
import { titleCase } from "./../../../Service/catalog";
import * as endpoint from "./../../../Service/endpoints";

function SubCategoryComponent({ match }) {
  const { subCategory } = match.params;
  const category = endpoint.apiCategorySlug(match.params.category);
  const citySlug = match.params.city || "delhi";
  const cityName = citySlug.charAt(0).toUpperCase() + citySlug.slice(1);
  const meta = getCategoryMeta(category);
  const fallbackName = titleCase(subCategory);

  return (
    <React.Fragment>
      <SeoMeta
        title={`${fallbackName} on Rent in ${cityName} | Voorent`}
        description={`Explore ${fallbackName.toLowerCase()} on rent in ${cityName} under ${meta.short.toLowerCase()} with flexible plans from Voorent.`}
        canonical={`https://voorent.com/${citySlug}/${category}/${subCategory}`}
        image={meta.image || "https://voorent.com/logo192.png"}
      />
      <HeaderComponent />
      <ProductListing
        mode="category"
        category={category}
        initialSub={subCategory}
        heading={(subName) => `${subName || fallbackName} on rent`}
        description={meta.description}
        crumbs={(subName) => [
          { label: "Home", to: endpoint.getPath("") },
          { label: meta.short, to: endpoint.getPath(category) },
          { label: subName || fallbackName, to: endpoint.getPath(`${category}/${subCategory}`) },
        ]}
      />
      <FooterComponent />
    </React.Fragment>
  );
}

export default SubCategoryComponent;
